module.exports = __webpack_public_path__ + "img/comment-icon.f2d2c448.svg";